module.exports = __webpack_public_path__ + "static/media/test27.15f81094.jpeg";